module.exports = "{#if type === 'flex'}\n<div class=\"kl-row kl-row--flex is-justify-{justify} is-align-{align} is-flex-{wrap} {class}\" gutter=\"{gutter}\">\n  {#inc this.$body}\n</div>\n{#else}\n<div class=\"kl-row {class}\" gutter=\"{gutter}\">\n  {#inc this.$body}\n</div>\n{/if}"


//////////////////
// WEBPACK FOOTER
// ../src/js/components/layout/KLRow/index.html
// module id = 553
// module chunks = 0